import { sanitizeHtml } from '@wix/wix-chatbot-common/browser';
import { isTextHebrew } from '@wix/wix-chatbot-common/locale';

export const isHtmlHebrew = (html?: string): boolean => {
  if (!html) {
    return false;
  }
  const temp = document.createElement('DIV');
  temp.innerHTML = sanitizeHtml(html);
  const stripped = temp.textContent || temp.innerText || '';
  return isTextHebrew(stripped);
};
